import * as cookieUtils from '../../../../utils/cookie';
import { COOKIE_EXPIRES, COOKIE_KEY, COOKIE_VALUE } from './const';
import classes from './styles/cookieAccept.module.scss';

export function hasAcceptedCookie() {
	return cookieUtils.getCookie(COOKIE_KEY) !== null;
}

export function hasCookiePortal() {
	const portal = document.querySelector('.cookie-accept');

	return portal !== null;
}

export function setCookieValues() {
	cookieUtils.setCookie(COOKIE_KEY, COOKIE_VALUE, {
		days: COOKIE_EXPIRES,
	});
}

export function setBodyPaddingStyles(top?: string) {
	document.body.style.paddingTop = typeof top === 'undefined' ? '' : top;
}

export function toggleBodyClass(add) {
	const targetClass = classes.body_hasCookieAcceptComponent;
	if (add) {
		!document.body.classList.contains(targetClass) && document.body.classList.add(targetClass);

		return;
	}

	document.body.classList.remove(targetClass);
}
